import React from "react";
import { VOTE_STATIC_PATH_V2 } from "@/api/staticPaths";
import { canv } from "@/canv/global";
import style from "../VoteWindow.module.css";

export function EmptyBoardInfo() {
    return (
        <div className={style.voteWindowEmpty}>
            <p className={style.voteWindowEmptyTitle}>Добавьте объекты на доску</p>
            <img
                src={`${canv.host}${VOTE_STATIC_PATH_V2}canNotStartVoting.png`}
                alt="illustration"
            />
            <p className={style.voteWindowEmptyText}>
                Голосование можно запустить, если на доске есть как минимум два объекта из списка:
            </p>
            <ul className={style.voteWindowEmptyList}>
                <li>стикеры</li>
                <li>фигуры</li>
                <li>изображения</li>
                <li>тексты</li>
                <li>карточки</li>
            </ul>
        </div>
    );
}
